import React from "react";
import "./Footer.scss"
import fb from "../../assets/icons/fb.svg"
import insta from "../../assets/icons/insta.svg"
import twitter from "../../assets/icons/twitter.svg"
import phone from "../../assets/icons/phone.svg"
import mail from "../../assets/icons/email.svg"
import loc from "../../assets/icons/location.svg"

const Footer = () => {
    return (
        <div className="Virasat-Footer">
            <div className="Virasat-Footer-top">
                <div className="Virasat-Footer-top-inner">
                    <div className="Virasat-Footer-top-inner-cont">
                        <div className="footer-virasat-header logo">
                            Virasat
                        </div>
                        <div className="footer-virasat-subheader">
                            Opening day is just around the corner, and we couldn’t be more excited! Want to be the first to know when we go live? Sign up now and we’ll send you a notification the moment our shop opens — so you don’t miss out on any of the action! </div>
                    </div>
                    <div className="Virasat-Footer-top-inner-cont">
                        <div className="footer-virasat-header">
                            About Us
                        </div>
                        <div className="footer-header-item">
                            <img alt="" src={phone} className="footer-header-item-icon" />
                            <div className="footer-header-item-text">
                                +44 1784 463978
                            </div>
                        </div>
                        <div className="footer-header-item">
                            <img alt="" src={mail} className="footer-header-item-icon" />
                            <div className="footer-header-item-text">
                                info@virasat.uk
                            </div>
                        </div>
                        <div className="footer-header-item">
                            <img alt="" src={loc} className="footer-header-item-icon" />
                            <div className="footer-header-item-text">
                                13-15, High Street, Staines-Upon-Thames, Surrey, TW18 4QY
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="Virasat-Footer-bottom">
                <div className="Virasat-Footer-bottom-inner">
                    <div className="footer-img-cont">
                        <img alt="" src={fb} className="footer-img-cont-icon" />
                        <img alt="" src={insta} className="footer-img-cont-icon" />
                        <img alt="" src={twitter} className="footer-img-cont-icon" />
                    </div>
                    <div className="copy-right-text-footer-vi">Copyright 2025 WITMEG. All Right Revered.</div>
                </div>
            </div>
        </div>
    )
}
export default Footer